import { c as _c } from "react/compiler-runtime";
import { EntityPlacementCtaTypeEnum } from '@cc-shopping/contracts/cross-site/marketplace/enums';
import { CTASearchParams } from '@cc-shopping/platform-analytics/lib/ctaSearchParams';
import { CdnImage, IMAGE_SIZES } from '@cc-shopping/ui/primitives/CdnImage';
import { Box } from '@mui/system';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import { CtaLink } from 'src/features/product-card/CTA/CtaLink';
type ReviewProductCardImageProps = {
  source: string;
  height: number;
};
export default function ReviewProductCardImage(t0) {
  const $ = _c(19);
  const {
    source,
    height
  } = t0;
  const {
    marketplaceEntity
  } = useReviewContext();
  const {
    details: t1,
    finishType,
    cta,
    ctaAnalytics
  } = marketplaceEntity;
  const {
    applyLink
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      name: "review_product_card_sticky",
      position: 0
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== ctaAnalytics) {
    t3 = {
      ...ctaAnalytics,
      section: t2
    };
    $[1] = ctaAnalytics;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = cta.type === EntityPlacementCtaTypeEnum.ApplyNow ? "nofollow" : undefined;
  const t5 = cta.type !== EntityPlacementCtaTypeEnum.ApplyNow;
  let t6;
  if ($[3] !== cta.type) {
    t6 = cta.type === EntityPlacementCtaTypeEnum.ApplyNow ? [CTASearchParams.MONETIZING, CTASearchParams.SHOPPING_FINISH] : [];
    $[3] = cta.type;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      objectFit: "contain",
      objectPosition: "top",
      mixBlendMode: "multiply"
    };
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== source) {
    t8 = <CdnImage style={t7} alt="product-card-image" src={source} fill={true} sizes={IMAGE_SIZES.PRODUCT_CARD} />;
    $[6] = source;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== height || $[9] !== t8) {
    t9 = <Box position="relative" height={height}>{t8}</Box>;
    $[8] = height;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== applyLink || $[12] !== finishType || $[13] !== t3 || $[14] !== t4 || $[15] !== t5 || $[16] !== t6 || $[17] !== t9) {
    t10 = <CtaLink analytics={t3} type="PRODUCT_IMAGE" href={applyLink} rel={t4} position="relative" target="_blank" finishType={finishType} isReview={t5} parameterActions={t6} data-testid="stickyCardImage">{t9}</CtaLink>;
    $[11] = applyLink;
    $[12] = finishType;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}